export default "__VITE_ASSET__NgBb9Cmu__"